import { FC } from 'react'
import { Avatar, FlexboxGrid, Panel } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'

import { Product } from '../../utils/types/Product'
import { getProductImageAltText } from '../../lib/text'
import { getSmallPreview, imageLoader } from '../../utils/images'
import { CartProduct } from '../../utils/types/Order'
import { isCartProduct } from '../../utils/types/guards/Order'
import CustomNotificationCard from '../CustomNotificationCard'

import styles from '../../styles/LowStockProductCard.module.less'

interface LowStockProductCardProps {
  product: Product | CartProduct
}

const LowStockProductCard: FC<LowStockProductCardProps> = ({ product }) => {
  const { t } = useTranslation('cart')

  const productImage = isCartProduct(product) ? imageLoader(product['order.product.mediaurl']) : imageLoader(getSmallPreview(product?.media?.[0]))
  const imageAltText = isCartProduct(product) ? product['order.product.name'] : getProductImageAltText(product)

  const productName = isCartProduct(product)
    ? `${product['order.product.name']} , ${product.attribute?.[0]['order.product.attribute.name'] || product['order.product.prodcode']}`
    : `${product['text.name']}, ${product['product.label']}`

  if (!isCartProduct(product) || product['order.product.id']) {
    return (
      <Panel
        bordered
        className={styles.panel}
      >
        <FlexboxGrid className="flex-flow-row">
          <FlexboxGrid.Item>
            <Avatar
              className={styles['product-logo']}
              size="lg"
              circle
              src={productImage}
              alt={imageAltText}
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item className="margin-top-spacer-half flex-shrink-col-dynamic">
            <h5>
              {productName}
            </h5>
            <p>
              {t(
                isCartProduct(product) || product['stock.stocklevel'] === 0
                  ? t('Removed since it is unavailable')
                  : t('Updated to {{ stock }} pcs since the stock is limited', { stock: product['stock.stocklevel'] }),
              )}
            </p>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Panel>
    )
  }

  return (
    <Panel
      bordered
      className={styles['unavailable-card']}
    >
      <CustomNotificationCard
        title={t('The availability of some products has changed')}
      >
        {t('Ask in the chat for a delivery estimates or alternative options for these product codes')}
        <b>
          {' '}
          {product['order.product.prodcode']}
        </b>
      </CustomNotificationCard>
    </Panel>
  )
}

export default LowStockProductCard
